const withClientContactPeople = clientContactPeople => prevProject => ({
    ...prevProject,
    clientContactPeople,
});

export default withClientContactPeople;
